// Lesson 4 — Calling Pung. The learner holds a pair of Red Dragons. Seat 1 is a
// pass-through bot whose lone honour IS a Red Dragon, so `EasyStrategy` discards
// it deterministically (usefulness −1, the unique minimum by a wide margin over
// its four runs), handing the learner the third Red Dragon to Pung. Pung is
// legal from any seat, so seat 1 — the first bot to move — is the discarder.

import { createDealBuilder, fillerBot } from './deckBuilder.js';
import type { LessonScript } from '../types.js';

const b = createDealBuilder();

const redA = b.honor('red');
const redB = b.honor('red');
const white = b.honor('white');

const human = [
  redA,
  redB,
  white,
  b.suit('man', 2),
  b.suit('man', 3),
  b.suit('man', 4),
  b.suit('pin', 5),
  b.suit('pin', 6),
  b.suit('pin', 7),
  b.suit('sou', 3),
  b.suit('sou', 4),
  b.suit('sou', 8),
  b.suit('pin', 9),
];

// Seat 1's lone honour is the third Red Dragon it will discard for the learner.
const seat1 = fillerBot(b, 'red', [['sou', 1], ['sou', 5], ['pin', 1], ['man', 6]]);
const seat2 = fillerBot(b, 'east', [['man', 1], ['man', 4], ['pin', 3], ['sou', 6]]);
const seat3 = fillerBot(b, 'south', [['pin', 4], ['sou', 7], ['man', 7], ['pin', 7]]);

const wall = [
  b.suit('man', 8),
  b.suit('sou', 5),
  b.suit('pin', 2),
  b.suit('man', 5),
];

export const lesson4Pung: LessonScript = {
  id: 'lesson-4-pung',
  titleKey: 'lesson.script.pung.title',
  deal: { hands: [human, seat1, seat2, seat3], wall },
  steps: [
    {
      instructionKey: 'lesson.script.pung.intro',
      expectedAction: { kind: 'info' },
      highlightTileIds: [redA.id, redB.id],
      autoAdvance: false,
    },
    {
      instructionKey: 'lesson.script.pung.discard',
      expectedAction: { kind: 'discard', tileId: white.id },
      highlightTileIds: [white.id],
      autoAdvance: true,
    },
    { instructionKey: 'lesson.script.pung.claim', expectedAction: { kind: 'claim', claim: 'pung' }, autoAdvance: true },
    { instructionKey: 'lesson.script.pung.done', expectedAction: { kind: 'info' }, autoAdvance: false },
  ],
};
